import "@fontsource-variable/inter";
import "@fontsource-variable/source-serif-4";
// Muss vor der App laden: Einstellung „Animationen aus“
import "@/version/motionPref";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Attach the currently selected Parto locale to every API request. This is
// evaluated for each request so switching between / and /en/ is reflected
// without requiring a page reload or per-form handling.
axios.interceptors.request.use((config) => {
  const isEnglishPage = window.location.pathname === "/en" || window.location.pathname.startsWith("/en/");
  config.headers = config.headers || {};
  config.headers["X-Parto-Site-Language"] = isEnglishPage ? "en" : "de";
  return config;
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
